<template>
  <div 
    class="fill-height"
    :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 280px; padding-top: 124px;` : `padding-bottom: 650px; padding-top: 64px;`">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-container
            class="infografis-page"
            :class="$vuetify.breakpoint.lgAndUp ? 'px-0 pt-0' : 'px-3 pt-0'">
            <!-- <HeroSection /> -->
        
            <v-card
              class="main-card"
              outlined>
              <v-card-title class="d-flex justify-space-between align-center infografis-toolbar pa-5">
                <div class="infografis-toolbar__left">
                  <div class="text-h6 font-weight-bold">Dashboard Infografis</div>
                  <div class="text-caption">Ringkasan data pembangunan dan produk hukum daerah.</div>
                  <div class="text-caption infografis-toolbar__hint mt-1">
                    Pilih tab SIMPELBANG atau JDIH untuk melihat detail masing-masing modul.
                  </div>
                </div>
                <v-tabs
                  v-model="tab"
                  class="dashboard-tabs"
                  background-color="transparent">
                  <v-tab href="#simpelbang-tab">SIMPELBANG</v-tab>
                  <v-tab href="#jdih-tab">JDIH</v-tab>
                </v-tabs>
              </v-card-title>
        
              <v-tabs-items v-model="tab">
                <v-tab-item value="simpelbang-tab">
                  <SimpelbangSection
                    :selected-year="selectedYear"
                    :selected-month="selectedMonth"
                    :selected-month-label="selectedMonthLabel"
                    :year-options="yearOptions"
                    :month-options="monthOptions"
                    :error-message="errorMessage"
                    :metric-cards-primary="metricCardsPrimary"
                    :metric-cards-secondary="metricCardsSecondary"
                    :simpelbang-grafik-error="simpelbangGrafikError"
                    :simpelbang-grafik-loading="simpelbangGrafikLoading"
                    :simpelbang-has-grafik-data="simpelbangHasGrafikData"
                    :simpelbang-grafik-rows="simpelbangGrafikRows"
                    :simpelbang-fisik-chart-options="simpelbangFisikChartOptions"
                    :simpelbang-fisik-series="simpelbangFisikSeries"
                    :simpelbang-keuangan-chart-options="simpelbangKeuanganChartOptions"
                    :simpelbang-keuangan-series="simpelbangKeuanganSeries"
                    :loading-summary-murni="loadingSummaryMurni"
                    :loading-summary="loadingSummary"
                    @update:year="handleYearChange"
                    @update:month="handleMonthChange"
                    :dpa-status="dpaStatus" />
                </v-tab-item>
                <v-tab-item value="jdih-tab">
                  <JdihSection
                    :selected-year="selectedYear"
                    :year-options="yearOptionsJdih"
                    :chart-height-jdih="chartHeightJdih"
                    :jdih-loading="jdihLoading"
                    :jdih-error="jdihError"
                    :jdih-has-chart-data="jdihHasChartData"
                    :jdih-chart-options="jdihChartOptions"
                    :jdih-chart-series="jdihChartSeries"
                    :jdih-summary-total="jdihSummaryTotal"
                    :jdih-summary-top-label="jdihSummaryTopLabel"
                    :jdih-status-summary-total="jdihStatusSummaryTotal"
                    :jdih-status-summary-top-label="jdihStatusSummaryTopLabel"
                    :jdih-status-loading="jdihStatusLoading"
                    :jdih-status-error="jdihStatusError"
                    :jdih-status-has-chart-data="jdihStatusHasChartData"
                    :jdih-status-chart-options="jdihStatusChartOptions"
                    :jdih-status-chart-series="jdihStatusChartSeries"
                    :jdih-bidang-loading="jdihBidangLoading"
                    :jdih-bidang-error="jdihBidangError"
                    :jdih-bidang-has-chart-data="jdihBidangHasChartData"
                    :jdih-bidang-chart-options="jdihBidangChartOptions"
                    :jdih-bidang-chart-series="jdihBidangChartSeries"
                    :jdih-bidang-summary-total="jdihBidangSummaryTotal"
                    :jdih-bidang-summary-top-label="jdihBidangSummaryTopLabel"
                    @update:year="handleYearChange" />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import HeroSection from '@/components/infografis/HeroSection.vue'
import JdihSection from '@/components/infografis/JdihSection.vue'
import SimpelbangSection from '@/components/infografis/SimpelbangSection.vue'

const JDIH_DOC_TYPE_URL = 'https://api.diskominfo.klaten.go.id/jdih/sites/doc/doc_type'
const JDIH_DOC_DATA_URL = 'https://api.diskominfo.klaten.go.id/jdih/sites/doc/data'
const JDIH_CATEGORY_URL = 'https://api.diskominfo.klaten.go.id/jdih/sites/home/category'
const JDIH_BASIC_AUTH = 'Basic ZGlza29taW5mbzpPbkRlbWFuZERpc2tvbWluZm9TaXN0ZW1BcHBz'
const SIMPELBANG_GRAFIK_SUMMARY_URL = 'https://api.diskominfo.klaten.go.id/simpelbang2024/rad/grafik_summary'

const JDIH_CHART_COLORS = [
  '#1e88e5', '#43a047', '#fb8c00', '#8e24aa', '#00acc1', '#e53935',
  '#3949ab', '#00897b', '#6d4c41', '#5c6bc0', '#7cb342', '#fdd835',
  '#ec407a', '#26a69a', '#ab47bc', '#78909c', '#ff7043', '#29b6f6'
]

const PRIMARY_METRIC_KEYS = [
  'grand_total_anggaran',
  'total_realisasi_keuangan',
  'grand_total_total_target_fisik',
  'grand_total_deviasi'
]

const CHART_HEIGHT_COMPACT = 360

export default {
  name: 'InfografisPage',
  components: {
    HeroSection,
    JdihSection,
    SimpelbangSection
  },
  data() {
    return {
      tab: 'simpelbang-tab',
      infografisApps: [
        {
          id: 'simpelbang',
          title: 'SIMPELBANG',
          description: 'Ringkasan anggaran, fisik, dan realisasi keuangan per OPD.',
          icon: 'mdi-chart-timeline-variant',
          accent: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)',
          accentSoft: 'rgba(13, 71, 161, 0.12)',
          iconColor: '#0d47a1',
          hash: 'simpelbang',
          actionLabel: 'Lihat data'
        },
        {
          id: 'jdih',
          title: 'JDIH',
          description: 'Grafik produk hukum dan status dokumen hukum daerah.',
          icon: 'mdi-scale-balance',
          accent: 'linear-gradient(135deg, #00695c 0%, #26a69a 100%)',
          accentSoft: 'rgba(0, 105, 92, 0.12)',
          iconColor: '#00695c',
          hash: 'jdih',
          actionLabel: 'Lihat grafik'
        }
      ],
      loading: false,
      loadingSummaryMurni: false,
      loadingSummary: false,
      errorMessage: '',
      jdihLoading: false,
      jdihError: '',
      jdihGrafikPayload: null,
      jdihStatusLoading: false,
      jdihStatusError: '',
      jdihStatusGrafikPayload: null,
      jdihBidangLoading: false,
      jdihBidangError: '',
      jdihBidangGrafikPayload: null,
      simpelbangGrafikLoading: false,
      simpelbangGrafikError: '',
      simpelbangGrafikSummary: [],
      summary: null,
      summaryMurni: null,
      selectedYear: 2026,
      selectedMonth: 1,
      chartHeightJdih: CHART_HEIGHT_COMPACT,
      infografisSectionNav: [
        { id: 'aplikasi', label: 'Aplikasi' },
        { id: 'simpelbang', label: 'SIMPELBANG' },
        { id: 'jdih', label: 'JDIH' }
      ],
      dpaDateConfig: null,
      dpaStatus: 'murni',
      metricFields: [
        { key: 'grand_total_anggaran', label: 'Total Anggaran Kumulatif', icon: 'mdi-cash-multiple', color: '#1b5fc1' },
        { key: 'grand_total_anggaran_p1', label: 'Total Anggaran P1', icon: 'mdi-file-document-edit', color: '#3949ab' },
        { key: 'grand_total_anggaran_perubahan', label: 'Total Anggaran Perubahan', icon: 'mdi-file-replace', color: '#5e35b1' },
        { key: 'grand_total_total_target_fisik', label: 'Target Fisik Bulan Terpilih', icon: 'mdi-target', color: '#1b5fc1' },
        { key: 'grand_total_realisasi_fisik', label: 'Total Realisasi Fisik', icon: 'mdi-run-fast', color: '#00acc1' },
        { key: 'grand_total_deviasi', label: 'Deviasi Fisik Bulan Terpilih', icon: 'mdi-chart-line', color: '#ef9c16' },
        { key: 'grand_total_target_keuangan', label: 'Anggaran Kas Perbulan (Rp)', icon: 'mdi-cash-multiple', color: '#fb8c00' },
        { key: 'total_realisasi_keuangan', label: 'Realisasi Keuangan Kumulatif', icon: 'mdi-wallet-outline', color: '#1ea971' },
        { key: 'grand_total_persentase_sp2d', label: 'Persentase SP2D terhadap Pagu Anggaran', icon: 'mdi-percent', color: '#546e7a' },
        { key: 'grand_total_persentase_sp2d_anggaran', label: 'Persentase SP2D terhadap Kas Perbulan', icon: 'mdi-finance', color: '#8e24aa' }
      ]
    }
  },
  computed: {
    yearOptions() {
      const startYear = 2024
      const endYear = new Date().getFullYear()
      const years = []
      for (let year = endYear; year >= startYear; year -= 1) {
        years.push(year)
      }
      return years
    },
    yearOptionsJdih() {
      const startYear = 1826
      const endYear = new Date().getFullYear()
      const years = []
      for (let year = endYear; year >= startYear; year -= 1) {
        years.push(year)
      }
      return years
    },
    selectedMonthLabel() {
      return this.monthOptions.find((item) => item.value === this.selectedMonth)?.label || '-'
    },
    metricCardsPrimary() {
      return PRIMARY_METRIC_KEYS.map((key) => {
        const field = this.metricFields.find((f) => f.key === key)
        return field ? this.buildMetricCard(field) : null
      }).filter(Boolean)
    },
    metricCardsSecondary() {
      const primary = new Set(PRIMARY_METRIC_KEYS)
      return this.metricFields
        .filter((f) => !primary.has(f.key))
        .map((field) => this.buildMetricCard(field))
    },
    jdihJenisSortedPoints() {
      const categories = (this.jdihGrafikPayload?.arr_year || []).map((label) => String(label || '').trim())
      const mappedSeries = this.mapJdihGrafikToSeries(this.jdihGrafikPayload)
      const firstSeries = Array.isArray(mappedSeries) && mappedSeries.length ? mappedSeries[0] : { name: '', data: [] }
      const data = (firstSeries.data || []).map((value) => {
        const n = Number(value)
        return Number.isFinite(n) ? n : 0
      })
      return categories
        .map((label, idx) => ({ label, value: data[idx] || 0 }))
        .sort((a, b) => b.value - a.value)
    },
    jdihChartSeries() {
      const points = this.jdihJenisSortedPoints
      return [
        {
          name: `Tahun ${this.selectedYear}`,
          data: points.map((point) => point.value)
        }
      ]
    },
    jdihHasChartData() {
      const years = this.jdihGrafikPayload?.arr_year
      return Array.isArray(years) && years.length > 0 && this.jdihChartSeries.length > 0
    },
    jdihChartOptions() {
      return this.buildJdihHorizontalBarOptions(this.jdihJenisSortedPoints)
    },
    jdihSummaryTotal() {
      return this.jdihJenisSortedPoints.reduce((sum, item) => sum + (Number(item?.value) || 0), 0)
    },
    jdihSummaryTopLabel() {
      return this.jdihJenisSortedPoints.length ? this.jdihJenisSortedPoints[0].label : ''
    },
    jdihStatusSummaryTotal() {
      return this.jdihStatusSortedPoints.reduce((sum, item) => sum + (Number(item?.value) || 0), 0)
    },
    jdihStatusSummaryTopLabel() {
      return this.jdihStatusSortedPoints.length ? this.jdihStatusSortedPoints[0].label : ''
    },
    jdihStatusChartSeries() {
      const points = this.jdihStatusSortedPoints
      return [
        {
          name: `Tahun ${this.selectedYear}`,
          data: points.map((point) => point.value)
        }
      ]
    },
    jdihStatusSortedPoints() {
      const categories = (this.jdihStatusGrafikPayload?.arr_year || []).map((label) => String(label || '').trim())
      const mappedSeries = this.mapJdihGrafikToSeries(this.jdihStatusGrafikPayload)
      const firstSeries = Array.isArray(mappedSeries) && mappedSeries.length ? mappedSeries[0] : { data: [] }
      const data = (firstSeries.data || []).map((value) => {
        const n = Number(value)
        return Number.isFinite(n) ? n : 0
      })
      return categories
        .map((label, idx) => ({ label, value: data[idx] || 0 }))
        .sort((a, b) => b.value - a.value)
    },
    jdihStatusHasChartData() {
      const years = this.jdihStatusGrafikPayload?.arr_year
      return Array.isArray(years) && years.length > 0 && this.jdihStatusChartSeries.length > 0
    },
    jdihStatusChartOptions() {
      return this.buildJdihHorizontalBarOptions(this.jdihStatusSortedPoints)
    },
    jdihBidangChartSeries() {
      const points = this.jdihBidangSortedPoints
      return [
        {
          name: `Tahun ${this.selectedYear}`,
          data: points.map((point) => point.value)
        }
      ]
    },
    jdihBidangSortedPoints() {
      const categories = (this.jdihBidangGrafikPayload?.arr_year || []).map((label) => String(label || '').trim())
      const mappedSeries = this.mapJdihGrafikToSeries(this.jdihBidangGrafikPayload)
      const firstSeries = Array.isArray(mappedSeries) && mappedSeries.length ? mappedSeries[0] : { data: [] }
      const data = (firstSeries.data || []).map((value) => {
        const n = Number(value)
        return Number.isFinite(n) ? n : 0
      })
      return categories
        .map((label, idx) => ({ label, value: data[idx] || 0 }))
        .sort((a, b) => b.value - a.value)
    },
    jdihBidangHasChartData() {
      const years = this.jdihBidangGrafikPayload?.arr_year
      return Array.isArray(years) && years.length > 0 && this.jdihBidangChartSeries.length > 0
    },
    jdihBidangChartOptions() {
      return this.buildJdihHorizontalBarOptions(this.jdihBidangSortedPoints)
    },
    jdihBidangSummaryTotal() {
      return this.jdihBidangSortedPoints.reduce((sum, item) => sum + (Number(item?.value) || 0), 0)
    },
    jdihBidangSummaryTopLabel() {
      return this.jdihBidangSortedPoints.length ? this.jdihBidangSortedPoints[0].label : ''
    },
    simpelbangGrafikRows() {
      const sourceRows = Array.isArray(this.simpelbangGrafikSummary) ? this.simpelbangGrafikSummary : []
      const byMonth = new Map()
      sourceRows
        .sort((a, b) => Number(a?.bulan_anggaran) - Number(b?.bulan_anggaran))
        .forEach((row) => {
          const month = Number(row?.bulan_anggaran)
          if (!Number.isFinite(month) || month < 1 || month > 12) return
          byMonth.set(month, row)
        })
      return this.monthOptions.map((item) => {
        const row = byMonth.get(item.value) || {}
        return {
          month: item.value,
          bulan_anggaran: String(item.value),
          anggaran_murni: row.anggaran_murni ?? null,
          anggaran_p1: row.anggaran_p1 ?? null,
          anggaran_perubahan: row.anggaran_perubahan ?? null,
          target_fisik: row.target_fisik ?? null,
          realisasi_fisik: row.realisasi_fisik ?? null,
          deviasi_fisik: row.deviasi_fisik ?? null,
          kas_per_bulan: row.kas_per_bulan ?? null,
          persentase_sp2d_pagu: row.persentase_sp2d_pagu ?? null,
          realisasi_keuangan_sp2d: row.realisasi_keuangan_sp2d ?? null,
          persentase_sp2d_kas_bulanan: row.persentase_sp2d_kas_bulanan ?? null
        }
      })
    },
    simpelbangHasGrafikData() {
      return this.simpelbangGrafikRows.length === this.monthOptions.length
    },
    simpelbangGrafikCategories() {
      return this.simpelbangGrafikRows.map((row) => {
        const found = this.monthOptions.find((item) => item.value === row.month)
        return found ? found.label : `Bulan ${row.month}`
      })
    },
    simpelbangFisikSeries() {
      return [
        {
          name: 'Target',
          data: this.simpelbangGrafikRows.map((row) => {
            const n = this.toNumber(row.target_fisik)
            return Number.isFinite(n) ? n : null
          })
        },
        {
          name: 'Realisasi',
          data: this.simpelbangGrafikRows.map((row) => {
            const n = this.toNumber(row.realisasi_fisik)
            return Number.isFinite(n) ? n : null
          })
        },
        {
          name: 'Deviasi',
          data: this.simpelbangGrafikRows.map((row) => {
            const n = this.toNumber(row.deviasi_fisik)
            return Number.isFinite(n) ? n : null
          })
        }
      ]
    },
    simpelbangFisikChartOptions() {
      return this.buildSimpelbangFisikChartOptions()
    },
    simpelbangKeuanganSeries() {
      const makeData = (key) => this.simpelbangGrafikRows.map((row) => {
        const n = this.toNumber(row[key])
        return Number.isFinite(n) ? n : null
      })
      const anggaranPerubahanData = makeData('anggaran_perubahan')
      const anggaranP1Data = makeData('anggaran_p1')
      const hasAnggaranP1 = anggaranP1Data.some((n) => Number.isFinite(n) && n !== 0)
      const hasAnggaranPerubahan = anggaranPerubahanData.some((n) => Number.isFinite(n) && n !== 0)
      const series = [
        { name: 'Anggaran Murni', type: 'column', yAxisIndex: 0, data: makeData('anggaran_murni') },
        { name: 'Anggaran Kas Perbulan (Rp)', type: 'column', yAxisIndex: 0, data: makeData('kas_per_bulan') },
        { name: 'Persentase SP2D terhadap Pagu', type: 'column', yAxisIndex: 1, data: makeData('persentase_sp2d_pagu') },
        { name: 'Realisasi Keuangan/SP2D (Rp)', type: 'column', yAxisIndex: 0, data: makeData('realisasi_keuangan_sp2d') },
        { name: 'Persentase SP2D terhadap Kas Perbulan', type: 'column', yAxisIndex: 1, data: makeData('persentase_sp2d_kas_bulanan') }
      ]
      if (hasAnggaranP1) {
        series.splice(0, 0, { name: 'Anggaran P1', type: 'column', yAxisIndex: 0, data: anggaranP1Data })
      }
      if (hasAnggaranPerubahan) {
        series.splice(2, 0, { name: 'Anggaran Perubahan', type: 'column', yAxisIndex: 0, data: anggaranPerubahanData })
      }
      return series
    },
    simpelbangKeuanganChartOptions() {
      return this.buildSimpelbangKeuanganChartOptions()
    },
    monthOptions() {
      return [
        { label: 'Januari', value: 1 },
        { label: 'Februari', value: 2 },
        { label: 'Maret', value: 3 },
        { label: 'April', value: 4 },
        { label: 'Mei', value: 5 },
        { label: 'Juni', value: 6 },
        { label: 'Juli', value: 7 },
        { label: 'Agustus', value: 8 },
        { label: 'September', value: 9 },
        { label: 'Oktober', value: 10 },
        { label: 'November', value: 11 },
        { label: 'Desember', value: 12 }
      ]
    }
  },
  mounted() {
    this.handleFilterChange()
  },
  methods: {
    handleYearChange(year) {
      this.selectedYear = year
      this.handleFilterChange({ withGrafik: true })
    },
    handleMonthChange(month) {
      this.selectedMonth = month
      this.handleFilterChange({ withGrafik: false })
    },
    goInfografisApp(app) {
      if (app.to) {
        this.$router.push(app.to)
        return
      }
      if (app.hash) {
        this.scrollToSection(app.hash)
      }
    },
    infografisScrollOffset() {
      const b = this.$vuetify.breakpoint
      if (b.xs) return 52
      if (b.sm) return 68
      if (b.md) return 84
      return 104
    },
    scrollToSection(id) {
      const cleanId = String(id).replace(/^#/, '')
      this.$nextTick(() => {
        const el = document.getElementById(cleanId)
        if (!el) return
        const offset = this.infografisScrollOffset()
        if (this.$vuetify && typeof this.$vuetify.goTo === 'function') {
          this.$vuetify.goTo(el, { duration: 480, offset, easing: 'easeInOutCubic' })
        } else {
          const top = el.getBoundingClientRect().top + window.pageYOffset - offset
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
        }
      })
    },
    buildMetricCard(field) {
      const colorOverrides = {
        grand_total_anggaran: '#1b5fc1',
        total_realisasi_keuangan: '#1ea971',
        grand_total_total_target_fisik: '#0c77d8',
        grand_total_deviasi: '#ef9c16'
      }
      const rawValue = field.key === 'grand_total_anggaran'
        ? this.summaryMurni?.grand_total_anggaran
        : this.summary?.[field.key]

      let color = colorOverrides[field.key] || field.color
      let statEmoji = null
      if (field.key === 'grand_total_anggaran') {
        statEmoji = '💰'
      } else if (field.key === 'total_realisasi_keuangan') {
        statEmoji = '📗'
      } else if (field.key === 'grand_total_total_target_fisik') {
        statEmoji = '🎯'
      } else if (field.key === 'grand_total_deviasi') {
        const deviasi = this.toNumber(String(rawValue).replace('%', ''))
        if (Number.isFinite(deviasi) && deviasi < 0) {
          statEmoji = '📉'
          color = '#d64949'
        } else {
          statEmoji = '📈'
          color = '#ef9c16'
        }
      }

      return {
        ...field,
        color,
        value: this.formatMetricValue(field.key, rawValue),
        description: this.metricDescriptionFor(field.key, rawValue),
        statEmoji
      }
    },
    metricDescriptionFor(key, value) {
      if (key === 'grand_total_anggaran') {
        return 'Akumulasi anggaran seluruh bulan pada tahun terpilih'
      }
      if (key === 'total_realisasi_keuangan') {
        return 'Nilai realisasi keuangan sampai bulan berjalan'
      }
      if (key === 'grand_total_total_target_fisik') {
        return `${this.selectedMonthLabel} tahun ${this.selectedYear}`
      }
      if (key === 'grand_total_deviasi') {
        const deviasi = this.toNumber(String(value).replace('%', ''))
        if (Number.isFinite(deviasi) && deviasi < 0) {
          return 'Perlu perhatian terhadap percepatan'
        }
        return 'Capaian di atas target'
      }
      return ''
    },
    mapJdihGrafikToSeries(payload) {
      const grafik = payload?.arr_grafik
      if (!Array.isArray(grafik)) return []
      return grafik.map((item) => ({
        name: String(item.name || '').trim(),
        data: (item.data || []).map((d) => {
          const n = Number(d)
          return Number.isFinite(n) ? n : 0
        })
      }))
    },
    buildJdihStackedBarOptions(payload, series, chartHeight) {
      const categories = (payload?.arr_year || []).map((y) => String(y))
      const colorCount = Math.max(series.length, 1)
      const colors = []
      for (let i = 0; i < colorCount; i += 1) {
        colors.push(JDIH_CHART_COLORS[i % JDIH_CHART_COLORS.length])
      }
      return {
        chart: { type: 'bar', stacked: true, toolbar: { show: true }, zoom: { enabled: true }, fontFamily: 'inherit' },
        plotOptions: { bar: { horizontal: false, borderRadius: 2, columnWidth: '58%' } },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            const n = Number(val)
            return Number.isFinite(n) ? String(Math.round(n)) : ''
          },
          style: {
            fontSize: '11px',
            fontWeight: 600
          },
          background: {
            enabled: true,
            foreColor: '#16324f',
            borderRadius: 4,
            padding: 4,
            opacity: 0.96,
            borderWidth: 0
          }
        },
        stroke: { width: 1, colors: ['#fff'] },
        xaxis: {
          categories,
          title: { text: 'Tahun', style: { fontSize: '12px' } },
          labels: { rotate: -35, style: { fontSize: '11px' }, hideOverlappingLabels: true }
        },
        yaxis: {
          title: { text: 'Jumlah', style: { fontSize: '12px' } },
          labels: {
            formatter: (val) => {
              const n = Number(val)
              return Number.isFinite(n) ? String(Math.round(n)) : ''
            }
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '11px',
          horizontalAlign: 'center',
          offsetY: 4,
          itemMargin: { horizontal: 6, vertical: 2 }
        },
        colors,
        fill: { opacity: 1 },
        tooltip: {
          shared: true,
          intersect: false,
          followCursor: true,
          style: { fontSize: '12px' },
          y: {
            formatter: (val) => {
              const n = Number(val)
              return Number.isFinite(n) ? `${Math.round(n)} dokumen` : ''
            }
          }
        },
        responsive: [{ breakpoint: 600, options: { chart: { height: chartHeight + 40 }, legend: { fontSize: '10px' } } }]
      }
    },
    buildJdihHorizontalBarOptions(points) {
      const sortedCategories = (points || []).map((p) => p.label)
      const sortedValues = (points || []).map((p) => {
        const n = Number(p?.value)
        return Number.isFinite(n) ? n : 0
      })
      const maxValue = sortedValues.length ? Math.max(...sortedValues) : 0
      const axisMax = Math.max(10, Math.ceil((maxValue + 10) / 10) * 10)
      const chartHeight = Math.max(620, sortedCategories.length * 34 + 120)

      // Random tapi konsisten: warna diturunkan deterministik dari label kategori.
      const colors = sortedCategories.map((label) => this.getDeterministicColor(label))

      return {
        chart: {
          type: 'bar',
          stacked: false,
          height: chartHeight,
          toolbar: { show: true },
          zoom: { enabled: false },
          fontFamily: 'inherit'
        },
        grid: {
          borderColor: 'rgba(22, 50, 79, 0.08)',
          strokeDashArray: 3,
          xaxis: {
            lines: { show: true }
          },
          yaxis: {
            lines: { show: false }
          },
          padding: {
            left: 26,
            right: 56
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            borderRadius: 6,
            barHeight: '54%',
            dataLabels: {
              position: 'right'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            const n = Number(val)
            return Number.isFinite(n) ? String(Math.round(n)) : ''
          },
          style: {
            fontSize: '11px',
            fontWeight: 600
          },
          offsetX: 4,
          background: {
            enabled: true,
            foreColor: '#16324f',
            borderRadius: 4,
            padding: 4,
            opacity: 0.96,
            borderWidth: 0
          }
        },
        xaxis: {
          categories: sortedCategories,
          min: 0,
          max: axisMax,
          tickAmount: 5,
          decimalsInFloat: 0,
          forceNiceScale: true,
          title: { text: 'Jumlah Dokumen', style: { fontSize: '12px' } },
          labels: {
            formatter: (val) => {
              const n = Number(val)
              return Number.isFinite(n) ? String(Math.round(n)) : ''
            }
          }
        },
        yaxis: {
          labels: {
            maxWidth: 420,
            style: { fontSize: '11px' }
          }
        },
        legend: { show: false },
        colors,
        tooltip: {
          y: {
            formatter: (val) => {
              const n = Number(val)
              return Number.isFinite(n) ? `${Math.round(n)} dokumen` : ''
            }
          }
        },
        // gunakan data terurut untuk chart horizontal ini
        noData: { text: 'Tidak ada data' }
      }
    },
    getDeterministicColor(seed) {
      const text = String(seed || '')
      let hash = 0
      for (let i = 0; i < text.length; i += 1) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i)
        hash |= 0
      }
      const hue = Math.abs(hash) % 360
      return `hsl(${hue}, 68%, 46%)`
    },
    buildSimpelbangFisikChartOptions() {
      return {
        chart: { type: 'line', toolbar: { show: true }, zoom: { enabled: true }, fontFamily: 'inherit' },
        stroke: { width: [3, 3, 3], curve: 'smooth' },
        markers: { size: 4 },
        dataLabels: { enabled: false },
        xaxis: { categories: this.simpelbangGrafikCategories, title: { text: 'Bulan', style: { fontSize: '12px' } } },
        yaxis: {
          title: { text: 'Persentase (%)', style: { fontSize: '12px' } },
          labels: {
            formatter: (val) => {
              const n = Number(val)
              return Number.isFinite(n) ? `${n.toFixed(2)}%` : ''
            }
          }
        },
        colors: ['#1e88e5', '#43a047', '#e53935'],
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (val) => {
              const n = Number(val)
              return Number.isFinite(n) ? `${n.toFixed(2)}%` : '-'
            }
          }
        },
        legend: { position: 'bottom', fontSize: '12px' }
      }
    },
    buildSimpelbangKeuanganChartOptions() {
      const percentValues = [
        ...this.simpelbangGrafikRows.map((row) => {
          const n = this.toNumber(row.persentase_sp2d_pagu)
          return Number.isFinite(n) ? n : 0
        }),
        ...this.simpelbangGrafikRows.map((row) => {
          const n = this.toNumber(row.persentase_sp2d_kas_bulanan)
          return Number.isFinite(n) ? n : 0
        })
      ]
      const maxPercent = percentValues.length ? Math.max(...percentValues) : 0
      const percentAxisMax = Math.max(10, Math.ceil(maxPercent / 10) * 10)
      return {
        chart: { type: 'line', stacked: false, toolbar: { show: true }, zoom: { enabled: true }, fontFamily: 'inherit' },
        stroke: {
          width: this.simpelbangKeuanganSeries.map((seriesItem) => (seriesItem.type === 'line' ? 3 : 0)),
          curve: 'smooth'
        },
        plotOptions: { bar: { columnWidth: '50%', borderRadius: 2 } },
        dataLabels: { enabled: false },
        xaxis: { categories: this.simpelbangGrafikCategories, title: { text: 'Bulan', style: { fontSize: '12px' } } },
        yaxis: [
          {
            title: { text: 'Nominal (Rp)', style: { fontSize: '12px' } },
            labels: {
              formatter: (val) => {
                const n = Number(val)
                if (!Number.isFinite(n)) return ''
                return new Intl.NumberFormat('id-ID').format(Math.round(n))
              }
            }
          },
          {
            opposite: true,
            title: { text: 'Persentase (%)', style: { fontSize: '12px' } },
            min: 0,
            max: percentAxisMax,
            tickAmount: Math.max(2, Math.min(8, Math.round(percentAxisMax / 10))),
            forceNiceScale: true,
            labels: {
              formatter: (val) => {
                const n = Number(val)
                return Number.isFinite(n) ? `${n.toFixed(2)}%` : ''
              }
            }
          }
        ],
        colors: ['#1e88e5', '#3949ab', '#7e57c2', '#26a69a', '#fb8c00', '#43a047', '#ef5350'],
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (val, context) => {
              const n = Number(val)
              if (!Number.isFinite(n)) return '-'
              const seriesName = context?.w?.config?.series?.[context.seriesIndex]?.name || ''
              const isPercent = seriesName.toLowerCase().includes('persentase')
              if (isPercent) return `${n.toFixed(2)}%`
              return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(n)
            }
          }
        },
        legend: { position: 'bottom', fontSize: '12px' }
      }
    },
    toNumber(value) {
      if (value === null || value === undefined || value === '') return NaN
      if (typeof value === 'number') return value
      const raw = String(value).trim()
      if (!raw) return NaN
      if (raw.includes(',') && raw.includes('.')) {
        const normalizedMixed = raw.replace(/\./g, '').replace(',', '.')
        return Number(normalizedMixed)
      }
      if (raw.includes(',')) return Number(raw.replace(',', '.'))
      return Number(raw)
    },
    hasFraction(value) {
      return Math.abs(value % 1) > 0
    },
    formatMetricValue(key, value) {
      if (value === null || value === undefined || value === '') return '-'
      const currencyKeys = [
        'grand_total_anggaran',
        'grand_total_anggaran_p1',
        'grand_total_anggaran_perubahan',
        'grand_total_target_keuangan',
        'total_realisasi_keuangan'
      ]
      const percentKeys = [
        'grand_total_total_target_fisik',
        'grand_total_realisasi_fisik',
        'grand_total_deviasi',
        'grand_total_persentase_sp2d',
        'grand_total_persentase_sp2d_anggaran'
      ]
      if (currencyKeys.includes(key)) {
        const numberValue = this.toNumber(value)
        if (Number.isFinite(numberValue)) {
          const showTwoDecimals = this.hasFraction(numberValue)
          return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: showTwoDecimals ? 2 : 0,
            maximumFractionDigits: showTwoDecimals ? 2 : 0
          }).format(numberValue)
        }
      }
      if (percentKeys.includes(key)) {
        const numberValue = this.toNumber(String(value).replace('%', ''))
        if (Number.isFinite(numberValue)) {
          return `${new Intl.NumberFormat('id-ID', {
            minimumFractionDigits: this.hasFraction(numberValue) ? 2 : 0,
            maximumFractionDigits: 2
          }).format(numberValue)}%`
        }
      }
      const numberValue = this.toNumber(value)
      if (Number.isFinite(numberValue)) {
        return new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: this.hasFraction(numberValue) ? 2 : 0,
          maximumFractionDigits: 2
        }).format(numberValue)
      }
      return String(value)
    },
    parseMonthFromDate(dateString) {
      if (!dateString) return null
      const date = new Date(dateString)
      if (Number.isNaN(date.getTime())) return null
      return date.getMonth() + 1
    },
    resolveDpaStatus() {
      const selectedMonth = Number(this.selectedMonth)
      const murniMonth = this.parseMonthFromDate(this.dpaDateConfig?.murni_date)
      const p1Month = this.parseMonthFromDate(this.dpaDateConfig?.p1_date)
      const perubahanMonth = this.parseMonthFromDate(this.dpaDateConfig?.perubahan_date)
      if (perubahanMonth !== null && selectedMonth >= perubahanMonth) return 'perubahan'
      if (p1Month !== null && selectedMonth >= p1Month) {
        if (perubahanMonth === null || selectedMonth < perubahanMonth) return 'p1'
      }
      if (murniMonth !== null && selectedMonth >= murniMonth) {
        if (
          (p1Month !== null && selectedMonth < p1Month) ||
          (p1Month === null && (perubahanMonth === null || selectedMonth < perubahanMonth))
        ) {
          return 'murni'
        }
      }
      return 'murni'
    },
    async fetchDataDpaConfig() {
      try {
        const query = new URLSearchParams({ tahun: String(this.selectedYear) })
        const response = await fetch(`https://api.diskominfo.klaten.go.id/simpelbang2024/rad/dpa?${query.toString()}`, {
          method: 'GET',
          headers: {
            Authorization: 'Basic b2ZmaWNlOk9uRGVtYW5kT2ZmaWNlU2lzdGVtQXBwcw==',
            'x-api-key': 'ee523544e8a644946058b0b30fa4db9c7e283cb6+675bcec6ee20543fba77baa8c38bd04b2e6c7204'
          }
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        const dpaData = payload?.results?.data
        this.dpaDateConfig = Array.isArray(dpaData) && dpaData.length > 0 ? dpaData[0] : null
        this.dpaStatus = this.resolveDpaStatus()
      } catch (error) {
        this.dpaDateConfig = null
        this.dpaStatus = 'murni'
        this.errorMessage = `Gagal mengambil data: ${error.message || 'Unknown error'}`
      }
    },
    async handleFilterChange({ withGrafik = true } = {}) {
      this.loading = true
      this.errorMessage = ''
      await this.fetchDataDpaConfig()
      const promises = [
        this.fetchDataMurni(),
        this.fetchData(),
        // this.fetchJdihChart(),
        // this.fetchJdihStatusChart(),
        // this.fetchJdihBidangChart()
      ]

      if (withGrafik) {
        promises.push(this.fetchSimpelbangGrafikSummary())
        promises.push(this.fetchJdihChart())
        promises.push(this.fetchJdihStatusChart())
        promises.push(this.fetchJdihBidangChart())
      }

      await Promise.all(promises)


      // await Promise.all([
      //   this.fetchDataMurni(),
      //   this.fetchData(),
      //   this.fetchSimpelbangGrafikSummary(),
      //   this.fetchJdihChart(),
      //   this.fetchJdihStatusChart(),
      //   this.fetchJdihBidangChart()
      // ])
      this.loading = false
    },
    async fetchSimpelbangGrafikSummary() {
      this.simpelbangGrafikLoading = true
      this.simpelbangGrafikError = ''
      try {
        const query = new URLSearchParams({ tahun_anggaran: String(this.selectedYear), limit: 1000000 })
        const response = await fetch(`${SIMPELBANG_GRAFIK_SUMMARY_URL}?${query.toString()}`, {
          method: 'GET',
          headers: {
            Authorization: 'Basic b2ZmaWNlOk9uRGVtYW5kT2ZmaWNlU2lzdGVtQXBwcw==',
            'x-api-key': 'ee523544e8a644946058b0b30fa4db9c7e283cb6+675bcec6ee20543fba77baa8c38bd04b2e6c7204'
          }
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        const rows =
          (Array.isArray(payload?.results) && payload.results) ||
          (Array.isArray(payload?.results?.data) && payload.results.data) ||
          (Array.isArray(payload?.data) && payload.data) ||
          (Array.isArray(payload) && payload) ||
          []
        this.simpelbangGrafikSummary = rows
      } catch (error) {
        this.simpelbangGrafikSummary = []
        this.simpelbangGrafikError = `Gagal memuat grafik SIMPELBANG: ${error.message || 'Unknown error'}`
      } finally {
        this.simpelbangGrafikLoading = false
      }
    },
    async fetchJdihChart() {
      this.jdihLoading = true
      this.jdihError = ''
      try {
        const docTypeQuery = new URLSearchParams({ limit: '1000000', 'par_id[nin]':'0' })
        const docDataQuery = new URLSearchParams({
          limit: '1000000',
          is_publish: 'Publish',
          tahun: String(this.selectedYear)
        })

        const [docTypeResponse, docDataResponse] = await Promise.all([
          fetch(`${JDIH_DOC_TYPE_URL}?${docTypeQuery.toString()}`, {
            method: 'GET',
            headers: { Authorization: JDIH_BASIC_AUTH }
          }),
          fetch(`${JDIH_DOC_DATA_URL}?${docDataQuery.toString()}`, {
            method: 'GET',
            headers: { Authorization: JDIH_BASIC_AUTH }
          })
        ])

        if (!docTypeResponse.ok) throw new Error(`HTTP ${docTypeResponse.status}`)
        if (!docDataResponse.ok) throw new Error(`HTTP ${docDataResponse.status}`)

        const docTypePayload = await docTypeResponse.json()
        const docDataPayload = await docDataResponse.json()

        const docTypes =
          (Array.isArray(docTypePayload?.results) && docTypePayload.results) ||
          (Array.isArray(docTypePayload?.results?.data) && docTypePayload.results.data) ||
          (Array.isArray(docTypePayload?.data) && docTypePayload.data) ||
          (Array.isArray(docTypePayload) && docTypePayload) ||
          []

        const docs =
          (Array.isArray(docDataPayload?.results) && docDataPayload.results) ||
          (Array.isArray(docDataPayload?.results?.data) && docDataPayload.results.data) ||
          (Array.isArray(docDataPayload?.data) && docDataPayload.data) ||
          (Array.isArray(docDataPayload) && docDataPayload) ||
          []

        if (!docTypes.length) {
          this.jdihGrafikPayload = null
          return
        }

        const normalizeTitle = (value) => String(value || '').trim().toLowerCase()
        const displayTitle = (value) => String(value || '').trim()

        const docTypeTitleMap = new Map()
        docTypes.forEach((item) => {
          const rawTitle = displayTitle(item?.title)
          const key = normalizeTitle(rawTitle)
          if (!key) return
          if (!docTypeTitleMap.has(key)) {
            docTypeTitleMap.set(key, rawTitle)
          }
        })

        const docLabelByTitle = new Map()
        const docCountByTitle = docs.reduce((acc, item) => {
          const rawDocTypeTitle = displayTitle(item?.doc_type_title)
          const key = normalizeTitle(rawDocTypeTitle)
          if (!key) return acc
          if (!docLabelByTitle.has(key)) {
            docLabelByTitle.set(key, rawDocTypeTitle)
          }
          acc.set(key, (acc.get(key) || 0) + 1)
          return acc
        }, new Map())

        const orderedDocTypeTitles = Array.from(docTypeTitleMap.entries())
        const categories = orderedDocTypeTitles.map(([, label]) => label)
        const counts = orderedDocTypeTitles.map(([key]) => docCountByTitle.get(key) || 0)

        // Keep unmatched titles from doc/data so total remains consistent with source API.
        Array.from(docCountByTitle.entries()).forEach(([key, count]) => {
          if (docTypeTitleMap.has(key)) return
          categories.push(docLabelByTitle.get(key) || 'Tanpa Jenis Dokumen')
          counts.push(count)
        })

        this.jdihGrafikPayload = {
          arr_year: categories,
          arr_grafik: [
            {
              name: `Tahun ${this.selectedYear}`,
              data: counts
            }
          ]
        }
      } catch (error) {
        this.jdihGrafikPayload = null
        this.jdihError = `Gagal memuat grafik JDIH: ${error.message || 'Unknown error'}`
      } finally {
        this.jdihLoading = false
      }
    },
    async fetchJdihStatusChart() {
      this.jdihStatusLoading = true
      this.jdihStatusError = ''
      try {
        const query = new URLSearchParams({
          limit: '1000000',
          is_publish: 'Publish',
          tahun: String(this.selectedYear)
        })
        const response = await fetch(`${JDIH_DOC_DATA_URL}?${query.toString()}`, {
          method: 'GET',
          headers: { Authorization: JDIH_BASIC_AUTH }
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        const docs =
          (Array.isArray(payload?.results) && payload.results) ||
          (Array.isArray(payload?.results?.data) && payload.results.data) ||
          (Array.isArray(payload?.data) && payload.data) ||
          (Array.isArray(payload) && payload) ||
          []

        if (!docs.length) {
          this.jdihStatusGrafikPayload = null
          return
        }

        const statusCategories = ['Mencabut Sebagian', 'Diubah', 'Berlaku', 'Tidak Berlaku']
        const normalize = (value) => String(value || '').trim().toLowerCase()
        const statusCount = docs.reduce((acc, item) => {
          const key = normalize(item?.status_option)
          if (!key) return acc
          acc.set(key, (acc.get(key) || 0) + 1)
          return acc
        }, new Map())

        this.jdihStatusGrafikPayload = {
          arr_year: statusCategories,
          arr_grafik: [
            {
              name: `Tahun ${this.selectedYear}`,
              data: statusCategories.map((status) => statusCount.get(normalize(status)) || 0)
            }
          ]
        }
      } catch (error) {
        this.jdihStatusGrafikPayload = null
        this.jdihStatusError = `Gagal memuat grafik status JDIH: ${error.message || 'Unknown error'}`
      } finally {
        this.jdihStatusLoading = false
      }
    },
    async fetchJdihBidangChart() {
      this.jdihBidangLoading = true
      this.jdihBidangError = ''
      try {
        const categoryQuery = new URLSearchParams({ limit: '1000000' })
        const docDataQuery = new URLSearchParams({
          limit: '1000000',
          is_publish: 'Publish',
          tahun: String(this.selectedYear)
        })

        const [categoryResponse, docDataResponse] = await Promise.all([
          fetch(`${JDIH_CATEGORY_URL}?${categoryQuery.toString()}`, {
            method: 'GET',
            headers: { Authorization: JDIH_BASIC_AUTH }
          }),
          fetch(`${JDIH_DOC_DATA_URL}?${docDataQuery.toString()}`, {
            method: 'GET',
            headers: { Authorization: JDIH_BASIC_AUTH }
          })
        ])

        if (!categoryResponse.ok) throw new Error(`HTTP ${categoryResponse.status}`)
        if (!docDataResponse.ok) throw new Error(`HTTP ${docDataResponse.status}`)

        const categoryPayload = await categoryResponse.json()
        const docDataPayload = await docDataResponse.json()

        const categories =
          (Array.isArray(categoryPayload?.results) && categoryPayload.results) ||
          (Array.isArray(categoryPayload?.results?.data) && categoryPayload.results.data) ||
          (Array.isArray(categoryPayload?.data) && categoryPayload.data) ||
          (Array.isArray(categoryPayload) && categoryPayload) ||
          []

        const docs =
          (Array.isArray(docDataPayload?.results) && docDataPayload.results) ||
          (Array.isArray(docDataPayload?.results?.data) && docDataPayload.results.data) ||
          (Array.isArray(docDataPayload?.data) && docDataPayload.data) ||
          (Array.isArray(docDataPayload) && docDataPayload) ||
          []

        if (!categories.length) {
          this.jdihBidangGrafikPayload = null
          return
        }

        const categoryCountMap = docs.reduce((acc, item) => {
          const key = String(item?.category_id || '').trim()
          if (!key) return acc
          acc.set(key, (acc.get(key) || 0) + 1)
          return acc
        }, new Map())

        const filteredCategories = categories.filter((item) => String(item?.id || '').trim())
        const xCategories = filteredCategories.map((item) => String(item?.title || '').trim() || `Kategori ${item.id}`)
        const yCounts = filteredCategories.map((item) => categoryCountMap.get(String(item.id)) || 0)

        this.jdihBidangGrafikPayload = {
          arr_year: xCategories,
          arr_grafik: [
            {
              name: `Tahun ${this.selectedYear}`,
              data: yCounts
            }
          ]
        }
      } catch (error) {
        this.jdihBidangGrafikPayload = null
        this.jdihBidangError = `Gagal memuat grafik bidang JDIH: ${error.message || 'Unknown error'}`
      } finally {
        this.jdihBidangLoading = false
      }
    },
    async fetchDataMurni() {
      this.loadingSummaryMurni = true
      try {
        const query = new URLSearchParams({
          limit: '2000000000000000',
          page: '1',
          search: '',
          tahun_anggaran: String(this.selectedYear),
          is_pengecualian: '1',
          year: String(this.selectedYear),
          month: String(this.selectedMonth),
          dpa_status: 'murni'
        })
        const response = await fetch(`https://api.diskominfo.klaten.go.id/simpelbang2024/rad/summary_opd_public?${query.toString()}`, {
          method: 'GET',
          headers: {
            Authorization: 'Basic b2ZmaWNlOk9uRGVtYW5kT2ZmaWNlU2lzdGVtQXBwcw==',
            'x-api-key': 'ee523544e8a644946058b0b30fa4db9c7e283cb6+675bcec6ee20543fba77baa8c38bd04b2e6c7204'
          }
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        this.summaryMurni = payload?.results || {}
      } catch (error) {
        this.summaryMurni = null
        this.errorMessage = `Gagal mengambil data: ${error.message || 'Unknown error'}`
      } finally {
        this.loadingSummaryMurni = false
      }
    },
    async fetchData() {
      this.loadingSummary = true
      try {
        const query = new URLSearchParams({
          limit: '2000000000000000',
          page: '1',
          search: '',
          tahun_anggaran: String(this.selectedYear),
          is_pengecualian: '1',
          year: String(this.selectedYear),
          month: String(this.selectedMonth),
          dpa_status: this.dpaStatus || 'murni'
        })
        const response = await fetch(`https://api.diskominfo.klaten.go.id/simpelbang2024/rad/summary_opd_public?${query.toString()}`, {
          method: 'GET',
          headers: {
            Authorization: 'Basic b2ZmaWNlOk9uRGVtYW5kT2ZmaWNlU2lzdGVtQXBwcw==',
            'x-api-key': 'ee523544e8a644946058b0b30fa4db9c7e283cb6+675bcec6ee20543fba77baa8c38bd04b2e6c7204'
          }
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        this.summary = payload?.results || {}
      } catch (error) {
        this.summary = null
        this.errorMessage = `Gagal mengambil data: ${error.message || 'Unknown error'}`
      } finally {
        this.loadingSummary = false
      }
    }
  }
}
</script>

<style scoped>
.infografis-page {
  margin-top: 16px;
}

.main-card {
  border: 1px solid rgba(21, 73, 135, 0.12) !important;
  border-radius: 28px !important;
  box-shadow: 0 18px 42px rgba(17, 64, 122, 0.1) !important;
  overflow: hidden;
  backdrop-filter: blur(8px);
}

.infografis-toolbar {
  gap: 16px;
  padding: 20px 22px 12px !important;
  border-bottom: 1px solid rgba(20, 78, 136, 0.08);
}

.infografis-toolbar__left {
  flex: 1 1 auto;
  min-width: 260px;
}

.infografis-toolbar__hint {
  color: #7d8ea4;
}

.dashboard-tabs {
  display: inline-flex;
  flex: 0 0 auto;
  width: auto;
  margin-left: auto;
  background: #edf3fb;
  padding: 3px;
  min-height: 30px;
  border-radius: 999px;
  border: 1px solid rgba(24, 89, 160, 0.1);
}

.dashboard-tabs::v-deep .v-slide-group,
.dashboard-tabs::v-deep .v-slide-group__wrapper,
.dashboard-tabs::v-deep .v-slide-group__content {
  width: auto !important;
  flex: 0 0 auto;
  min-height: 28px;
  height: 28px;
}

.dashboard-tabs::v-deep .v-tabs-slider-wrapper {
  display: none;
}

.dashboard-tabs::v-deep .v-tab {
  min-width: 0;
  min-height: 28px;
  height: 28px;
  border-radius: 999px;
  color: #6f7f92 !important;
  text-transform: none;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  padding: 0 14px !important;
}

.dashboard-tabs::v-deep .v-tab--active {
  color: #ffffff !important;
  background: linear-gradient(135deg, #1757b8, #0c77d8);
  box-shadow: 0 8px 18px rgba(18, 95, 192, 0.22);
}

@media (max-width: 720px) {
  .infografis-toolbar {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .dashboard-tabs {
    margin-left: 0;
  }
}
</style>
